<template>
  <!-- 回收站彻底删除,单拿出来，要不样式有问题 -->
  <div class="right_box1">
    <el-button size="mini" type="danger" @click="delAll" v-if="this.tabName == 'fifth'">批量彻底删除</el-button>
  </div>
  <div class="right_box">
    <el-switch @change="getList" v-model="changeF" active-text="是否显示报税手机号" v-if="tabName =='first'" style="margin-right:10px"></el-switch>
    <el-dropdown v-if="tabName == 'first'" split-button type="success" @click="addCustomerCom" size="mini" style="margin-right:10px" :hide-on-click="false">
      新增客户
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item>
            <span @click="daoruCustomer">导入客户</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <!-- <el-button size="mini" type="danger" @click="goRecycles" v-if="this.tabName == 'first'">批量删除</el-button> -->
    <!-- <span class="right_box1"><el-button size="mini" type="danger" @click="delAll" v-if="this.tabName == 'first'">批量彻底删除</el-button></span> -->
    <el-button size="mini" type="danger" @click="delAll" v-if="this.tabName == 'first'">彻底删除</el-button>
    <el-button size="mini" type="primary" plain v-if="tabName == 'first'" @click="gather">采集</el-button>
    <!-- <el-button size="mini" type="primary" plain v-if="tabName == 'first'" @click="skipCollection" :loading="skipLoading">跳过采集</el-button> -->
    <el-dropdown size="mini" style="margin-left:10px;margin-right:10px" :hide-on-click="false" v-if="tabName == 'first'">
      <el-button size="mini" type="primary">
        更多<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <template #dropdown>
        <el-dropdown-menu style="text-align:center">
          <el-dropdown-item command="a">
            <span @click="handleCommand()">建账采集</span>
          </el-dropdown-item>
          <el-dropdown-item command="b">
            <span @click="skipCollection">跳过采集</span>
            <!-- <el-button size="mini" type="primary" @click="skipCollection" :loading="skipLoading">跳过采集</el-button> -->
          </el-dropdown-item>
          <el-dropdown-item command="c">
            <span @click="handleMigrate()">账套迁移</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
  <el-table stripe :data="list" :height="contentStyleObj" style="width: 100%" border size="mini" @selection-change="handleSelectionChange" v-loading="loading"  @sort-change="sortChange">
    <el-table-column align="center" prop="id" type="selection" min-width="55" />
    <!-- <el-table-column align="center" type="index" label="序号" width="55"  fixed="left" /> -->
    <el-table-column sortable="custom" label="编号" align="center" prop="sort" width="80" fixed="left" v-if="this.tabName == 'first' || this.tabName == 'seventh' || this.tabName == 'sixth'">
      <template #default="scope">
        <span @click="saveSort(scope.row)" style="color: orange;cursor: pointer;">{{ sortNumber(scope.row.sortCom)}}</span>  
      </template>
    </el-table-column>
    <el-table-column prop="name" label="公司名称" min-width="280" >
      <template #default="scope">
        <span v-if="scope.row.type == '1'" class="xgmStyle">小</span>
        <span v-if="scope.row.type == '2'" class="ybStyle">般</span>
        <span @click="$goEtax(scope.row.id)" style="cursor:pointer" type="text" v-if=" this.tabName == 'seventh' || this.tabName == 'sixth' || this.tabName == 'eighth'">{{ scope.row.name }}</span>
        <span v-else>{{ scope.row.name }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="startAccountPeriod" label="启用账期" min-width="80">
      <template #default="scope">
        <span>{{ scope.row.startAccountPeriod }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" v-if="changeF" prop="mobileRec" label="报税手机号" min-width="130">
      <template #default="scope">
        <span>{{ scope.row.mobileRec }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="accountSystem" label="会计制度" width="180">
      <template #default="scope">
        <span>{{ scope.row.accountSystem }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="districtName" label="所属区域" min-width="80">
      <template #default="scope">
        <span>{{ scope.row.districtName }}</span>  
      </template>
    </el-table-column>
    <el-table-column align="center" prop="districtName" label="停报时间" min-width="180" v-if="this.tabName == 'ninth'">
      <template #default="scope">
        <span>{{$parseTime(scope.row.updatedAt, "{y}-{m}-{d}")}}</span>  
      </template>
    </el-table-column>
    <el-table-column align="center" prop="districtName" label="停报原因" min-width="180" v-if="this.tabName == 'ninth'">
      <template #default="scope">
        <span>{{ scope.row.remark }}</span>  
      </template>
    </el-table-column>
    <el-table-column align="center" prop="manager" label="法人代表" min-width="80" v-if="this.tabName == 'first' || this.tabName == 'second' || this.tabName == 'third' || this.tabName == 'fourth' || this.tabName == 'fifth'">
      <template #default="scope">
        <span>{{ scope.row.manager }}</span>  
      </template>
    </el-table-column>
    <!-- <el-table-column align="center" prop="manager" label="财务责任人" min-width="80" v-if="this.tabName == 'sixth' || this.tabName == 'seventh' || this.tabName == 'eighth'">
      <template #default="scope">
        <span>{{ scope.row.manager }}</span>  
      </template>
    </el-table-column> -->
    <el-table-column align="left" prop="content" label="备注" min-width="120" v-if="this.tabName == 'sixth' || this.tabName == 'seventh' || this.tabName == 'eighth'">
      <template #default="scope">
        <el-popover v-model:visible="scope.row.visible" placement="bottom" :width="350">
          <el-input
            v-model="scope.row.content"
            :rows="4"
            type="textarea"
            placeholder="请输入"
          />
          <div style="text-align: right; margin-top: 10px">
            <el-button size="mini" type="primary" @click="scope.row.visible = false">取消</el-button>
            <el-button size="mini" type="primary" @click="editNote(scope.row)">确定</el-button>
          </div>
          <template #reference>
            <span class="xgmStyle" @click="smallNotes(scope.row.id)">记</span>
          </template>
        </el-popover>
        <span>{{scope.row.content}}</span>
      </template>
    </el-table-column>
    <el-table-column  prop="districtName" label="建账采集状态" min-width="130" v-if="this.tabName == 'first'">
      <template #default="scope">
        <div class="item_icon">
          <p v-if="scope.row.cjjzStatus == '0'"><i class="el-icon-info"></i>{{$setUpStatusCj(scope.row.cjjzStatus)}}
          </p>
          <p v-if="scope.row.cjjzStatus == '1'"><i class="el-icon-info"></i>{{$setUpStatusCj(scope.row.cjjzStatus)}}
          </p>
          <p v-if="scope.row.cjjzStatus == '2'"><i class="el-icon-info"></i>{{$setUpStatusCj(scope.row.cjjzStatus)}}</p>
          <p v-if="scope.row.cjjzStatus == '3'"><i class="el-icon-success"></i>
          <el-tooltip class="item" effect="dark" :content="scope.row.cjjzLog" placement="top-start">
            <span size="mini" class="sbcg" style="border: 0;">{{$setUpStatusCj(scope.row.cjjzStatus)}}</span>
          </el-tooltip>
          </p>
          <p v-if="scope.row.cjjzStatus == '4'"><i class="el-icon-error"></i>
          <el-tooltip class="item" effect="dark" :content="scope.row.cjjzLog" placement="top-start">
            <span size="mini" style="border: 0;color:red">{{$setUpStatusCj(scope.row.cjjzStatus)}}</span>
          </el-tooltip>
          </p>
          <p v-if="scope.row.cjjzStatus == '5'"><i class="el-icon-info"></i>{{$setUpStatusCj(scope.row.cjjzStatus)}}</p>
          <p v-if="scope.row.cjjzStatus == '6'"><i class="el-icon-info"></i>{{$setUpStatusCj(scope.row.cjjzStatus)}}</p>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="address" label="状态" min-width="300" class-name="small_cell" v-if="this.tabName == 'first' || this.tabName == 'second' || this.tabName == 'third' || this.tabName == 'fourth' || this.tabName == 'fifth'">
      <template #default="scope">
        <el-tooltip placement="top" :disabled="scope.row.FailReason == ''">
          <template #content> {{scope.row.FailReason}} </template>
          <div class="item_icon" v-if="scope.row.setUpStatusCj == 6">
            <i class="el-icon-warning"></i>
            <p>{{ setUpStatus1(scope.row.setUpStatusCj) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusCj == 1">
            <i class="el-icon-success"></i>
            <p>{{ setUpStatus1(scope.row.setUpStatusCj) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusCj == 2">
            <i class="el-icon-success"></i>
            <p>{{ setUpStatus1(scope.row.setUpStatusCj) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusCj == 3">
            <i class="el-icon-info"></i>
            <p>{{ setUpStatus1(scope.row.setUpStatusCj) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusCj == 4">
            <i class="el-icon-error"></i>
            <p style="color:red">{{ setUpStatus1(scope.row.setUpStatusCj) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusCj == 5">
            <i class="el-icon-error"></i>
            <p style="color:red">{{ setUpStatus1(scope.row.setUpStatusCj) }}</p>
          </div>
        </el-tooltip>
        <el-tooltip placement="top" :disabled="scope.row.FailReason == ''">
          <template #content> {{scope.row.FailReason}} </template>
          <div class="item_icon" v-if="scope.row.setUpStatusJz == 6">
            <i class="el-icon-warning"></i>
            <p>{{ setUpStatus2(scope.row.setUpStatusJz) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusJz == 1">
            <i class="el-icon-success"></i>
            <p>{{ setUpStatus2(scope.row.setUpStatusJz) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusJz == 2">
            <i class="el-icon-info"></i>
            <p>{{ setUpStatus2(scope.row.setUpStatusJz) }}</p>
          </div>
        </el-tooltip>
        <el-tooltip placement="top" :disabled="scope.row.PpFailReason == ''">
          <template #content> 
            <div v-html="Tobreak(scope.row.PpFailReason)"></div>
          </template>
          <div class="item_icon" v-if="scope.row.setUpStatusPp == 6">
            <i class="el-icon-warning"></i>
            <p>{{ setUpStatus3(scope.row.setUpStatusPp) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusPp == 1">
            <i class="el-icon-success"></i>
            <p>{{ setUpStatus3(scope.row.setUpStatusPp) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusPp == 2">
            <i class="el-icon-error"></i>
            <p>{{ setUpStatus3(scope.row.setUpStatusPp) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusPp == 3">
            <i class="el-icon-info"></i>
            <p>{{ setUpStatus3(scope.row.setUpStatusPp) }}</p>
          </div>
          <div class="item_icon" v-else-if="scope.row.setUpStatusPp == 4">
            <i class="el-icon-error"></i>
            <p style="color:red">{{ setUpStatus3(scope.row.setUpStatusPp) }}</p>
          </div>
        </el-tooltip>  
      </template>
    </el-table-column>
    <el-table-column align="center" prop="address" label="操作" min-width="300" v-if="this.tabName == 'first' || this.tabName == 'second' || this.tabName == 'third' || this.tabName == 'fourth' || this.tabName == 'fifth'">
      <template #default="scope">
        <el-button v-if="this.tabName != 'fifth'" @click="handleUpdate(scope.row)" size="mini" type="primary" plain>编辑</el-button>
        <el-button v-if="this.tabName != 'fifth'" size="mini" @click="add_ea_subject_balance(scope.row)" plain type="warning">建账</el-button>
        <el-button v-if="this.tabName != 'fifth'" size="mini" @click="companyfp(scope.row)" plain type="success">分配</el-button>
        <!-- <el-button size="mini" plain type="danger" v-if="this.tabName == 'first'" @click="goRecycle(scope.row)">删除</el-button> -->
        <el-button size="mini" plain type="success" v-if="this.tabName == 'fifth'" @click="recycleRecover(scope.row)">还原</el-button>
        <el-button size="mini" plain type="danger" v-if="this.tabName == 'fifth'" @click="delCustomer(scope.row)">彻底删除</el-button>
        <el-button size="mini" plain type="primary" v-if="this.tabName == 'first'" @click="goBook(scope.row)">转移到记账客户</el-button>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="address" label="操作" min-width="300" v-if="this.tabName == 'sixth' || this.tabName == 'seventh' || this.tabName == 'eighth'">
      <template #default="scope">
        <div v-if="scope.row.crmComId == 0">
          <el-button @click="$goEtax(scope.row.id)" size="mini" type="primary" plain>进入账簿</el-button>
          <el-button size="mini" @click="InTax(scope.row.id)" plain type="warning">进入税局</el-button>
          <el-dropdown size="mini">
            <qzf-button type="primary" size="mini" plain style="margin-left:10px">
              更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
            </qzf-button>
            <template #dropdown>
              <el-dropdown-menu style="text-align:center">
                <el-dropdown-item>
                  <el-button v-if="scope.row.isHelp != 1" size="mini" type="text" @click="empower(scope.row)">请求协助</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button v-if="scope.row.isHelp == 1" size="mini" @click="cancelEmpower(scope.row)" type="text">取消协助</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button size="mini" type="text" @click="createCompanyInfo(scope.row)">编辑</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button size="mini" type="text" @click="companyfp(scope.row)">分配</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button size="mini" type="text" @click="stopCompany(scope.row)">停报</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <div v-else>
          <el-tooltip v-if="scope.row.errLog" class="item" effect="dark" :content="scope.row.errLog" placement="top-start">
            <el-button v-if="scope.row.errLog" size="mini" type="text" @click="gatherCJ(scope.row)">重新迁移</el-button>
          </el-tooltip>
          <el-button v-else size="mini" type="text" @click="gatherCJ(scope.row)">迁移</el-button>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="address" label="操作" min-width="380" v-if="this.tabName == 'ninth'">
      <template #default="scope">
        <el-button @click="$goEtax(scope.row.id)" size="mini" type="primary" plain>进入账簿</el-button>
        <el-button size="mini" @click="recoveryCom(scope.row)" plain type="success">还原到记账客户</el-button>
        <el-button size="mini" @click="recoveryAddCom(scope.row)" plain type="warning">还原到新增客户</el-button>
        <el-button size="mini" plain type="danger" @click="goRecycle(scope.row)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
  <!-- 分配 -->
  <companyFp ref="companyFp" code="addCustomer" @success="getList"></companyFp>
  <div class="bottom_style">
    <div class="bottom_button">
      <div v-if="this.tabName == 'first' || this.tabName == 'second'|| this.tabName == 'third' || this.tabName == 'fourth' || this.tabName == 'fifth'">
        <el-button size="mini" type="primary" plain v-if="this.tabName == 'first' && changeF" @click="settingMobile">批量设置税局手机号</el-button>
        <el-button size="mini" type="success" plain v-if="this.tabName !== 'fifth'" @click="companyfpAll">批量分配</el-button>
        <el-button size="mini" type="warning" plain v-if="this.tabName == 'first' || this.tabName == 'second'" @click="automatic" :loading="noNeedLoading">批量设为无需建账</el-button>
        <el-button size="mini" type="warning" plain v-if="this.tabName == 'fourth'">批量设为未建账</el-button>
        <el-button size="mini" plain type="success" v-if="this.tabName == 'first'" @click="goAllBook()">批量转移到记账客户</el-button>
      </div>
      <!-- 记账客户 -->
      <div v-if="this.tabName == 'sixth' || this.tabName == 'seventh'|| this.tabName == 'eighth'">
        <el-button size="mini" type="primary" plain v-if="this.tabName == 'seventh'" @click="settingMobile">批量设置税局手机号</el-button>
        <el-button size="mini" type="primary" plain v-if="this.tabName == 'seventh'" @click="nilReturn">设为零申报</el-button>
        <el-button size="mini" type="primary" plain v-if="this.tabName == 'sixth'" @click="removeNilReturn">移除零申报</el-button>
        <el-button size="mini" type="success" plain @click="companyfpAll">批量分配</el-button>
        <el-button size="mini" type="danger" plain @click="stopAllCompany">批量停报</el-button>
      </div>
      <div v-if="this.tabName == 'ninth'">
        <el-button size="mini" type="success" plain @click="recoveryAllCom">批量还原到记账客户</el-button>
        <el-button size="mini" type="primary" plain @click="recoveryAllAddCom">批量还原到新增客户</el-button>
      </div>
      <div v-if="this.tabName == 'fifth'">
        <el-button size="mini" type="primary" plain @click="recycleAllRecover">批量还原</el-button>
      </div>
    </div>
    <div class="pagination">
      <qzf-pagination v-show="userTotal>0" :total="userTotal" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
    </div>
  </div>
  <qzf-import type="daoruCustomer" ref="daoruCustomer" name="客户" @success="getList()" @handleSuccess="getListBegin"></qzf-import>
  <addCustomers @success="getList" ref="addCustomerCom"></addCustomers>
  <!-- 导入客户todo -->
  <el-dialog destroy-on-close title="提示" v-model="dialogTableVisibledaorukehu">
    <div style="margin-bottom:10px;">
      <span style="color: #67c23a;margin-right:20px">导入成功条数:{{callList.success_total}}</span>
      <span style="color:#F15A24;margin-right:20px">导入失败条数:{{callList.fail_total}}</span>
      <span style="color:#F15A24" v-if="callList.fail_reason">导入失败原因:{{callList.fail_reason}}</span>
    </div>
    <div style="height: 450px;overflow: auto;">
      <el-table :data="callList.fail_list" size="mini" border>
        <el-table-column align="center" property="name" label="导入失败公司名称"></el-table-column>
        <el-table-column align="center" property="remark" label="原因"></el-table-column>
      </el-table>
    </div>
    <div style="margin: 15px 0; padding-bottom:10px">
      <el-button style="float: right;margin-left:10px" @click="dialogTableVisibledaorukehu = false" size="mini" type="primary">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { eaCompanyList, changeStatus, delCompany ,saveEaCompany ,comMemoryInfo , comMemorySave ,saveEaCompanySort} from "@/api/company"
// import { jumpCollection } from "@/api/taxTask"
import { companyMove } from "@/api/move"
import { automaticAccountCreation } from "@/api/build"
import { sendHelp,helpOver } from "@/api/help.js"
import companyFp  from "./companyFp";
import addCustomers from "./addCustomers";
import { sendTask } from "@/api/collection"
export default {
  props: {
    tabName: String,
    listQuery: {}
  },
  data() {
    return {
      list:[],
      ids:undefined,
      datas:undefined,
      datacj:[],
      userTotal:0,
      selects:[],
      loading:false,  //表格加载
      loadingCJ: false,
      noNeedLoading:false,
      skipLoading:false,
      gatherId: [],
      dialogTableVisibledaorukehu:false,
      callList: [],
      visible:false,
      content:'',
      changeF:true
    }
  },
  components: {
    companyFp,
    addCustomers
  },
  created(){
    this.getList()
    this.contentStyleObj= this.$getHeight(320)
    this.initBus()
  },
  methods:{
    initBus(){
      this.$bus.on("refreshTask", () => {
        //刷新业务
        let status = false
        this.list.forEach(res => {
          if(res.setUpStatusCj == 3 || res.setUpStatusPp == 3) {
            status = true
          }
        })
        if(this.tabName == 'first' ||  this.tabName == 'fifth') {
          if(status == true) {
            this.getList()
          }
        }
      });
    },
    // 请求协助
    empower(row){
      this.$confirm('确认使用远程协助?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sendHelp({comId:row.id}).then(res=>{
          if(res.data.msg == 'success'){
            this.$message({
              message: "请求成功",
              type: "success"
            });
            this.getList()
            this.$bus.emit('contentTable')
          }
        })
      })
    },
    // 取消协助
    cancelEmpower(row){
      this.$confirm('确认取消远程协助?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        helpOver({comId:row.id}).then(res=>{
          if(res.data.msg == 'success'){
            this.$message({
              message: "已取消",
              type: "success"
            });
            this.getList()
          }
        })
      })
    },
    handleCommand() {
      // this.$store.dispatch('commons/setParam', {addAccountsId: e.id})
      this.$store.dispatch('tagsView/delCachedViewByName', "addAccounts")
      this.$router.push({
        path: "../../company/addAccounts.vue",
        name: "addAccounts"
      });
    },
    //账套迁移
    handleMigrate() {
      this.$store.dispatch('tagsView/delCachedViewByName', "accountMigrate")
      this.$router.push({
        path: "../../company/accountMigrate.vue",
        name: "accountMigrate"
      });
    },
      //分配
    companyfp(row){
      // if(row.setUpStatusJz == 6){
      //   this.$qzfMessage("请先进行建账", 1)
      //   return
      // }
      let ids = row.id
      ids = [ids]
      this.$refs.companyFp.init(ids,row)
    },
    companyfpAll(){
      let statuss = false
      this.selects.map(v=>{
        if(v.setUpStatusJz == 6){
          statuss = true
        }
      })
      // if(statuss){
      //   this.$qzfMessage("请先进行建账", 1)
      //   return
      // }
      this.$refs.companyFp.init(this.ids)
    },
    handleSelectionChange(val) {
      this.selects = val;
      let ids = []
      val.map(v=>{
        ids.push(v.id)
      })
      this.ids = ids
      this.datas = val.map(v=>{
        return {comId: v.id}
      })
      this.datacj = val.map(v=>{
        return v.id
      })
      // this.$emit('gather',this.datacj)
    },
    gather() {
      if(!this.ids){
        this.$qzfMessage("请选择公司", 1)
        return
      }
      let param = {
        taskName: 'tax-cj-jianzhang',
        comIds: this.datacj
      }
      this.loading = true
      sendTask(param).then(res => {
        this.loading = false
        if(res.data.msg == "success") {
          this.$qzfMessage('任务已发起',3)
          this.getList()
        }
      })
    },
    //记账客户采集
    gatherCJ(row) {
      this.loading = true
      this.$confirm('要发起迁移任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        companyMove({id: row.id}).then(res => {
          if(res.data.msg == 'success') {
            this.$message({
              type: 'success',
              message: '任务已发起!'
            });
            this.getList()
          }
          this.loading = false
        })
      }).catch(() => {
        this.loading = false
      });
    },
    skipCollection() {
      if(!this.ids){
        this.$qzfMessage("请选择公司", 1)
        return
      }
      this.skipLoading = true
      let param = {
        taskName: 'tax-cj-jump',
        comIds: this.datacj
      }
      sendTask(param).then(res => {
        this.skipLoading = false
        if(res.data.msg == "success") {
          this.$qzfMessage('任务已发起',3)
          this.getList()
        }
      })
    },
    getList(){
      this.loading = true
      if(this.listQuery.changeF == true){
        this.listQuery.change = 1
      }else{
        this.listQuery.change = 0
      }
      eaCompanyList(this.listQuery).then(res=>{
        this.loading = false
        this.list = res.data.data.list
        this.userTotal = res.data.data.total
      })
    },
    // 建账
    add_ea_subject_balance(e) {
      if(e.setUpStatusCj != '1' && e.setUpStatusCj != '2'){
          this.$message({
          message: '请先采集信息',
          type: 'warning'
          });
          return
      }
        // 新版跳转
      this.$store.dispatch('commons/setParam', {addCustomerComId: e.id})
      this.$store.dispatch("tagsView/delCachedViewByName", "subject_balance_uploadExcel_new");
      this.$router.push({
        path: "/company/subject_balance_uploadExcel_new",  
      });
    },
    setUpStatus1(e) {
      let num = e;
      if (num == 1) {
        return "已采集";
      } else if (num == 6) {
        return "未采集";
      } else if (num == 2) {
        return "跳过采集";
      } else if (num == 3) {
        return "采集中";
      } else if (num == 4) {
        return "采集失败";
      } else if (num == 5) {
        return "部分采集失败";
      }
    },
    setUpStatus2(e) {
      let num = e;
      if (num == 1) {
        return "已建账";
      } else if (num == 6) {
        return "未建账";
      }else if (num == 2) {
        return "无需建账";
      }
    },
    setUpStatus3(e) {
      let num = e;
      if (num == 1) {
        return "已匹配";
      } else if (num == 6) {
        return "未匹配";
      } else if (num == 2) {
        return "部分匹配失败";
      } else if (num == 3) {
        return "匹配中";
      } else if (num == 4) {
        return "匹配失败";
      }
    },
    handleUpdate(e){
      this.$store.dispatch('commons/setParam', {editCustomerComId: e})
      this.$router.push({
        path: "/company/comInfo",
        name:"editCustomer"
      });
    },
      // 批量无需建账
    automatic(){
      let statuss = false
      console.log(this.selects)
      this.selects.map(v=>{
        if(v.setUpStatusCj != 1 && v.setUpStatusCj != 2){
          statuss = true
        }
      })
      if(statuss){
        this.$qzfMessage("请先进行采集", 1)
        return
      }
      if(this.datas){
        let param = {
          params:this.datas
        }
        this.noNeedLoading = true
        automaticAccountCreation(param).then(res=>{
          this.noNeedLoading = false
            if(res.data.msg == "success"){
              this.$qzfMessage("设置成功") 
              this.getList()
            }
        })
      }else{
        this.$qzfMessage("请选择公司", 1) 
      }
    },
    createCompanyInfo(e) {
      this.$store.dispatch('commons/setParam', {editCustomerComId: e})
      this.$router.push({
        path: "/company/editCustomer",
        name: "editCustomer"
      });
    },
    // skipCollection(){
    //   if(!this.ids){
    //     this.$qzfMessage("请选择公司", 1)
    //     return
    //   }
    //   jumpCollection(this.datas).then(res=>{
    //     if(res.data.msg == "success"){
    //       this.getList()
    //       this.$bus.emit('loadingClose')
    //       this.$qzfMessage("跳过采集成功")
    //     }else{
    //       this.$bus.emit('loadingClose')
    //       this.$qzfMessage("跳过采集失败",2)
    //     }
    //   })
    // },
    stopCompany(row){
      let that = this
      this.$prompt('请输入停报原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        if(!value){
          that.$qzfMessage("请输入停报原因", 1)
          return
        }
        row.status = 3
        row.remark = value
        changeStatus([row]).then(res=>{
          if(res.data.msg == "success"){
            that.$qzfMessage("设置成功")
            that.getList()
            that.$bus.emit('stopReportingUpdate')
          }
        })
      })


      
    },
    stopAllCompany(){
      if(this.selects.length == 0){
        this.$qzfMessage("请选择公司", 1) 
        return
      }
      this.selects.map(v=>{
        v.status = 3
      })
      changeStatus(this.selects).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("设置成功")
          this.getList()
          this.$bus.emit('stopReportingUpdate')
        }
      })
    },
    recoveryCom(row){
      row.status = 2
      changeStatus([row]).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("设置成功")
          this.getList()
          this.$bus.emit('addCustomerUpdate')
        }
      })
    },
    recoveryAllCom(){
      if(this.selects.length == 0){
        this.$qzfMessage("请选择公司",1)
        return
      }
      this.selects.map(v=>{
        v.status = 2
      })
      changeStatus(this.selects).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("设置成功")
          this.getList()
          this.$bus.emit('addCustomerUpdate')
        }
      })
    },
    recoveryAddCom(row){
      row.status = 1
      changeStatus([row]).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("设置成功")
          this.getList()
          this.$bus.emit('addCustomerUpdate')
        }
      })
    },
    recoveryAllAddCom(){
      if(this.selects.length == 0){
        this.$qzfMessage("请选择公司",1)
        return
      }
      this.selects.map(v=>{
        v.status = 1
      })
      changeStatus(this.selects).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("设置成功")
          this.getList()
          this.$bus.emit('addCustomerUpdate')
        }
      })
    },
    nilReturn(){
      if(this.selects.length == 0){
        this.$qzfMessage("请选择公司",1)
        return
      }
      this.selects.map(v=>{
        v.accountingType = 1
      })
      changeStatus(this.selects).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("设置成功")
          this.getList()
        }
      })
    },
    removeNilReturn(){
      if(this.selects.length == 0){
        this.$qzfMessage("请选择公司",1)
        return
      }
      this.selects.map(v=>{
        v.accountingType = 2
      })
      changeStatus(this.selects).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("设置成功")
          this.getList()
        }
      })
    },
    goRecycle(row){
      row.status = 9
      this.$confirm('确定要删除该公司吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeStatus([row]).then(res=>{
          if(res.data.msg == "success"){
            this.$qzfMessage("删除成功")
            this.getList()
          }
        })
      });
    },

    goRecycles(){
      if(this.selects.length == 0){
        this.$qzfMessage("请选择公司",1)
        return
      }
      this.selects.map(v=>{
        v.status = 9
      })
      this.$confirm('确定要批量彻底删除这些公司吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeStatus(this.selects).then(res=>{
          if(res.data.msg == "success"){
            this.$qzfMessage("删除成功")
            this.getList()
          }
        })
      });
    },
    delCustomer(row){
      row.status = 9
      this.$confirm('确定要彻底删除该公司吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delCompany([row]).then(res=>{
          if(res.data.msg == "success"){
            this.$qzfMessage("删除成功")
            this.getList()
          }
        })
      });
    },
    delAll(){
      if(this.selects.length == 0){
        this.$qzfMessage("请选择公司",1)
        return
      }
      this.selects.map(v=>{
        v.status = 9
      })
      this.$confirm('确定要批量彻底删除这些公司吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        delCompany(this.selects).then(res=>{
          this.loading = false
          if(res.data.msg == "success"){
            this.$qzfMessage("删除成功")
            this.getList()
          }
        })
      });
    },
    settingMobile(){
      if(this.selects.length == 0){
        this.$qzfMessage("请选择公司",1)
        return
      }
      this.$prompt('请输入手机号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue:'',
        inputPattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,
        inputErrorMessage: '手机号格式不正确',
      }).then(({ value }) => {
        console.log(value);
        this.selects.map(v=>{
          v.mobileRec = value
        })
        console.log(this.selects);
        saveEaCompany({list:this.selects}).then(res=>{
          if(res.data.msg == "success"){
            this.$qzfMessage("设置成功")
            this.getList()
          }
        })
      })
    },
    Tobreak(val){
      return val.replace(/[\r\n]/g, '<br/>')
    },
    recycleRecover(row){
      row.status = 3
      this.$confirm('确定要还原该公司吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeStatus([row]).then(res=>{
          if(res.data.msg == "success"){
            this.$qzfMessage("还原成功")
            this.getList()
          }
        })
      });
    },
    recycleAllRecover(){
      if(this.selects.length == 0){
        this.$qzfMessage("请选择公司",1)
        return
      }
      this.selects.map(v=>{
        v.status = 3
      })
      this.$confirm('确定要还原该些公司吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeStatus(this.selects).then(res=>{
          if(res.data.msg == "success"){
            this.$qzfMessage("还原成功")
            this.getList()
          }
        })
      });
    },
    getListBegin(e){
      this.callList = e
      this.dialogTableVisibledaorukehu = true
      this.getList()
    },
    addCustomerCom(){
      this.$refs.addCustomerCom.handleCreate()
    },
    daoruCustomer(){
      this.$refs.daoruCustomer.handRedImport()
    },
    smallNotes(id){
      console.log(id);
      this.visible = true
      comMemoryInfo({comId:id}).then(res=>{
        console.log(res);
      })
    },
    editNote(row){
      comMemorySave({comId:row.id,content:row.content}).then(res=>{
        if(res.data.msg == "success"){
          row.visible = false
          this.$qzfMessage("保存成功")
        }
      })
    },
    goBook(row){
      if(row.setUpStatusJz == 6){
        this.$qzfMessage("请先进行建账", 1)
        return
      }
      row.status = 2
      this.$confirm('确定要转到记账客户吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeStatus([row]).then(res=>{
          if(res.data.msg == "success"){
            this.$qzfMessage("设置成功")
            this.getList()
          }
        })
      });
    },
    goAllBook(){
      if(this.selects.length == 0){
        this.$qzfMessage("请选择公司", 1) 
        return
      }
      let statuss = false
      this.selects.map(v=>{
        if(v.setUpStatusJz == 6){
          statuss = true
        }
      })
      if(statuss){
        this.$qzfMessage("请先进行建账", 1)
        return
      }
      this.selects.map(v=>{
        v.status = 2
      })
      this.$confirm('确定要转到记账客户吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeStatus(this.selects).then(res=>{
          if(res.data.msg == "success"){
            this.$qzfMessage("设置成功")
            this.getList()
          }
        })
      });
    },
     // 公司编号
    saveSort(row){
      this.$prompt('请输入编号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        saveEaCompanySort({id: row.id,sortCom: value}).then(res=>{
          this.getList()
          this.$message({
            type: 'success',
            message: '保存成功'
          });
        })
      })
    },
    sortNumber(e){
      if(!e){
        return "默认"
      }else{
        return e
      }
    },
    // 表格排序
    sortChange(data) {
      if(data.order == "descending"){
        this.listQuery.orderBy = "ea_company.sort_com desc,ea_company.id desc"
      }else{
        this.listQuery.orderBy = "ea_company.sort_com,ea_company.id desc"
      }
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.small_cell {
  div{
    padding-left: 2px !important;
    padding-right: 0 !important;
  }
}
.item_icon{
  display: inline-block;
  width: 32%;
  padding: 1px 3px;
  padding-right: 10px;
  
  cursor: pointer;
  i{
    display: inline-block;
    line-height: 28px;
    font-size: 16px;
  }
  .el-icon-error{
    color: #f56c6c;
  }
  .el-icon-success{
    color: #67c23a;
  }
  .el-icon-circle-check{
    color: #67c23a;
  }
  .el-icon-info{
    color: #409eff
  }
  .el-icon-warning{
    color: #e6a23c;
  }
  .el-icon-warning-outline{
    color: #e6a23c;
  }

  p{
    display: inline-block;
    font-size: 14px;
    line-height: 28px;
    color: #333;
  }
}
.right_box {
  position: absolute;
  right: 19px;
  top: 13px;
}
.right_box1 {
  float: right;
  width: 30%;
  text-align: right;
  margin-bottom: 5px;
}

</style>
<style scoped lang="scss">
.el-table {
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
</style>